// extracted by mini-css-extract-plugin
export default {"nav":"NavPanel_nav__9QXXn","icon":"NavPanel_icon__bkWXQ","label":"NavPanel_label__g0Qq8","theme-btn":"NavPanel_theme-btn__bb-ln"};